import gql from 'graphql-tag';

const UPDATE_CAMPAIGN_ORDER_SALESFORCE_ID = gql`
  mutation UpdateCampaignOrderSalesforceId(
    $where: CampaignOrderWhereUniqueInput!
    $data: CampaignOrderUpdateInput!
  ) {
    updateCampaignOrder(where: $where, data: $data) {
      id
      salesforceId
    }
  }
`;

export default UPDATE_CAMPAIGN_ORDER_SALESFORCE_ID;
